<div *ngIf="exportPreviewData$ | async as previewData" [ngClass]="{ divider: !coverPage }" class="header d-flex justify-content-between">
  <div>
    <img [src]="previewData.logo" alt="header logo" />
  </div>
  <div *ngIf="!coverPage" class="brokerage">
    <span class="me-2 text-capitalize">{{ previewData.title }}</span>
    <span class="date">{{ previewData.displayDate }}</span>
  </div>
</div>
